import { ShoppingBagOutlined } from '@mui/icons-material';
import { Badge, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { useCartContext } from 'src/context/CartProvider/useCartContext';

const CartLinkButton = () => {
  const { totalQuantity } = useCartContext();
  const { user } = useAuthContext();
  const badgeContent = user?.main_address?.store_data?.slug_name
    ? totalQuantity
    : undefined;

  return (
    <Box display="flex" alignItems="center">
      <Link
        to="/cart"
        className="nav-link"
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <Button
          variant="contained"
          size="small"
          sx={{
            height: '35px',
            minWidth: '40px',
            padding: '0px',
            borderRadius: ({ shape }) => `${shape.borderRadius * 2}px`,
          }}
        >
          <Badge badgeContent={badgeContent} color="error">
            <ShoppingBagOutlined fontSize="small" />
          </Badge>
        </Button>
      </Link>
    </Box>
  );
};

export default CartLinkButton;
